export function exposeBuildVersion(): void {
  window.martech = { ...window.martech, version: __BUILD_VERSION__ };
}
